import { useEffect, useState } from 'react';

import { useModal } from 'react-modal-hook';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSearchParam } from 'react-use';

import ModalIniciarContato from 'components/ModalIniciarContato';
import PrivateRoute from 'components/PrivateRoute';
import Agendamentos from 'pages/Agendamentos';
import Atendimentos from 'pages/Atendimentos';
import Contatos from 'pages/Contatos';
import Grupos from 'pages/Grupos';
import Historico from 'pages/Historico';
import { useAppDispatch } from 'store';
import { fetchContato } from 'store/reducers/atendimentos';
import { ContatoInterface } from 'store/reducers/contatos';

export default function Routes() {
  const dispatch = useAppDispatch();
  const [contato, setContato] = useState<ContatoInterface>();

  const contactId = useSearchParam('contactId');

  const handleDeleteContactIdParam = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('contactId');
    window.history.replaceState({}, document.title, url);
  };

  const [showModalIniciarContato, hideModalIniciarContato] = useModal(
    ({ in: open }) => (
      <ModalIniciarContato
        open={open}
        contato={contato}
        onClose={() => {
          hideModalIniciarContato();
          setContato(undefined);

          handleDeleteContactIdParam();
        }}
        onSuccess={() => {
          handleDeleteContactIdParam();
          setContato(undefined);
        }}
      />
    ),
    [contato],
  );

  useEffect(() => {
    if (!contactId) return;

    dispatch(fetchContato(contactId))
      .unwrap()
      .then(contato => {
        setContato(contato);
      })
      .catch(() => {
        handleDeleteContactIdParam();
      });
  }, [contactId, dispatch]);

  useEffect(() => {
    if (contato) {
      showModalIniciarContato();
    }
  }, [contato, showModalIniciarContato]);

  return (
    <Switch>
      <PrivateRoute exact path="/">
        <Atendimentos />
      </PrivateRoute>

      <PrivateRoute path="/grupos">
        <Grupos />
      </PrivateRoute>

      <PrivateRoute path="/contatos">
        <Contatos />
      </PrivateRoute>

      <PrivateRoute path="/historico">
        <Historico />
      </PrivateRoute>

      <PrivateRoute path="/agendamentos">
        <Agendamentos />
      </PrivateRoute>

      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
}
